import React, { Component, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Segment, Tab, Dropdown, Statistic, Message, Dimmer, Loader, Image, Popup } from 'semantic-ui-react';
import moment from 'moment';
import If from '../../utils/If';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import { Buffer } from 'buffer';


import styled from 'styled-components';



import { useDropzone } from 'react-dropzone';

//const Excel = require('exceljs');
//const ExcelJS = require('exceljs');
//import ExcelJS from "exceljs/dist/es5/exceljs.browser";
import Excel from "exceljs";





const inlineStyle = {
    modal: {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
    }
};

const StyledTable = styled(Table)`
  &&& {
    border-spacing: 0px;
    margin-top: -10px;
    margin-bottom: 0px;
    padding: 0px 0px;
   }    
`;

const StyledTableFooter = styled(Table.Footer)`
&&& 
 th{
    padding: 2px 2px !important;
    margin: 0px 0px 0px 0px !important;
}

`;


const StyledTableHeader = styled(Table.Header)`
&&& th {
    padding: 0px;
    margin: 0px 0px 0px 0px;
}
`;

const StyledTableBody = styled(Table.Body)`
&&& 
 td{
    padding: 0px 0px !important;
    margin: 0px 0px 0px 0px !important;
}

`;




const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};




function StyledDropzone({ props,
    concimktplaceid
    , conciListMktPlace
    , conciarquivojson
    , marketplacesConciliacaoHandleChangeAction
    , marketplacesConciliacaoImportAction
    , marketplacesConciliacaoImportArquivoAction
    , marketplacesConciliacaoListImportacoesAction
    , marketplacesConciliacaoDeleteAction
}) {


    const handleDropMktPlace = (e, { value }) => {
        // console.log(value)
        marketplacesConciliacaoHandleChangeAction({ target: { 'name': 'concimktplaceid', 'value': value.toString() } })

    }

    function trataNumeroPedido(valor) {
        if (!valor) return null;

        const numeroPedido = Number(
            valor
                .toString()
                .replace(/-.*/, '')   // remove sufixo "-A"
                .replace(/^0+/, '')   // remove zeros à esquerda
        );

        return numeroPedido;
    }


    function tratapedidoleroy(campo) {
        let valor = 0;

        try {
            var str = campo;
            str = str.replace(/[^0-9]/g, "");
            valor = Number.parseInt(str);

        } catch (error) {

        }

        return valor;


    }

    function trataParcelaAtual(parcela) {
        const numeroParcela = Number(
            parcela.match(/^\d+/)[0]
        );

        return numeroParcela;
    }

    const onDrop = useCallback(acceptedFiles => {
        // console.log('passou aqui')

        if (acceptedFiles.length > 0) {

            const file = acceptedFiles[0];

            const reader = new FileReader();

            reader.readAsArrayBuffer(file)
            reader.onload = () => {



                //xlsx----------------------------------------------
                const buffer = reader.result;
                const wb = new Excel.Workbook();

                let dados = [];
                let maadeiramadeira = "";
                wb.xlsx.load(buffer).then(workbook => {
                    //console.log(workbook, 'workbook instance')
                    workbook.eachSheet((sheet, id) => {
                        //console.log('linhas:' + sheet.length);
                        sheet.eachRow((row, rowIndex) => {
                            //cabeçalho/colunas do excel
                            if (rowIndex == 1) {
                                // console.log('colunas:' + row.values.length)
                                maadeiramadeira = row.values[5]
                            } else {

                                const magalu = row.values[2]
                                //leroy merlin layout
                                if (magalu != "Magalu" && maadeiramadeira != "Pedido MM") {
                                    dados.push({
                                        pedido: (row.values[7] == null ? trataNumeroPedido(row.values[5]) : row.values[7]) //NÃºmero da transaÃ§Ã£o
                                        , tipo: row.values[12]//Tipo 
                                        , parc_atual: '0'
                                        , parc_total: '0'
                                        //, debito: (row.values[15] != null  ? parseFloat(Number(row.values[15]).toFixed(2)) : 0)//DÃ©bito
                                        //, credito: (row.values[16] != null  ? parseFloat(Number(row.values[16]).toFixed(2)) : 0)//CrÃ©dito
                                        , valor: ((row.values[15] != null ? parseFloat(Number(row.values[15]).toFixed(2)) : 0) == 0 ? (row.values[16] != null ? parseFloat(Number(row.values[16]).toFixed(2)) : 0) : (row.values[15] != null ? parseFloat(Number(row.values[15]).toFixed(2)) : 0))
                                        , taxa: 0

                                    })
                                }
                                //Madeira Madeira layout
                                else if (maadeiramadeira === 'Pedido MM') {

                                    // console.log(row.values)
                                    let numeros = "";
                                    let valorNumerico = 0;
                                    let ultimoCampo = row.values[8] === undefined ? '0' : row.values[8];// Último elemento do array

                                    if (typeof ultimoCampo === 'string') {
                                        // console.log(ultimoCampo)
                                        numeros = ultimoCampo.match(/\d+/g); // Extrai todos os números do último campo
                                        valorNumerico = parseFloat(row.values[2].replace(/[^\d,-]/g, '').replace(',', '.'));
                                        // Seu código continua aqui...
                                    } else {
                                        // if (ultimoCampo == undefined) {
                                        //     numeros = ultimoCampo.match('1 / 1');
                                        // }
                                        valorNumerico = parseFloat(row.values[2].replace(/[^\d,-]/g, '').replace(',', '.'));
                                        // console.log(valorNumerico)
                                        // Tratar o caso em que ultimoCampo não é uma string
                                        // console.log('ERRO:', ultimoCampo)
                                        // console.error("O último campo não é uma string.");
                                    }
                                    // console.log(numeros)

                                    // console.log(numeros, "MM")
                                    if (numeros == '0' || numeros == 0) {
                                        // console.log('TARIFA', row.values[4])
                                        dados.push({
                                            pedido: Number(row.values[4]) ? Number(row.values[4]) : 0
                                            , tipo: row.values[3]
                                            , parc_atual: '1'
                                            , parc_total: '1'
                                            , valor: valorNumerico
                                            , taxa: 0
                                        })
                                    } else {
                                        // console.log('OUTROS VALORES', row.values[4])
                                        dados.push({
                                            pedido: Number(row.values[4]) ? Number(row.values[4]) : 0
                                            , tipo: row.values[3]
                                            , parc_atual: numeros[0]
                                            , parc_total: numeros[1]
                                            , valor: valorNumerico
                                            , taxa: 0
                                        })
                                    }
                                    // console.log(dados)

                                }
                                //Magalu layout
                                else {

                                    const taxa1 = parseFloat(Number(row.values[25]))
                                    const taxa2 = parseFloat(Number(row.values[27]))
                                    dados.push({
                                        pedido: tratapedidoleroy(row.values[5]) //NÃºmero da transaÃ§Ã£o
                                        , tipo: row.values[9]//Tipo de pagamento
                                        , parc_atual: row.values[19] !== 'N/A' ? trataParcelaAtual(row.values[19]) : 0
                                        , parc_total: row.values[10] !== 'N/A' ? row.values[10] : 0
                                        , valor: ((row.values[28] != null ? parseFloat(Number(row.values[28]).toFixed(2)) : 0))
                                        , taxa: (row.values[27] != 'N/A' ? taxa1 + taxa2 : 0)
                                        , taxa_ted: row.values[27]
                                    })

                                }
                            }
                        })
                    })
                })


                //fs.readFileSync(entidade.conciarquivobuffer)


                //console.log('file:');
                //console.log(file);

                // console.log(dados)
                marketplacesConciliacaoImportArquivoAction(dados, buffer, file.name)
                //---------------------------------------------------
            }

        }





    }, []);

    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject,
        acceptedFiles,
        //fileRejectionItems
    } = useDropzone({
        onDrop
        , maxFiles: 1
        //, accept: '.xlsx, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        , accept: '.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const removeAll = () => {

        acceptedFiles.length = 0
        acceptedFiles.splice(0, acceptedFiles.length)
        //inputRef.current.value = ''

    }


    function refreshPage() {
        window.location.reload();
    }


    const style = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

    const files = acceptedFiles.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));







    return (
        <div className="container">
            <div>
                <div style={{ textAlign: "right" }}>
                    <Popup
                        trigger={
                            <p style={{ display: "inline-block", marginRight: "20px", fontWeight: "bold", marginLeft: "10px" }}>Template Leroy</p>
                        }
                        flowing
                        hoverable
                        pinned
                        on={["hover", "click"]}>
                        Número da transação, Coluna <b>"G"</b><br />
                        Descrição, Coluna <b>"K"</b><br />
                        Tipo, Coluna <b>"L"</b><br />
                        Valor, Coluna<b>"N"</b><br />

                    </Popup>
                    <Popup
                        trigger={
                            <p style={{ display: "inline-block", marginRight: "20px", fontWeight: "bold", marginLeft: "10px" }}>Template Magazine Luiza</p>
                        }
                        flowing
                        hoverable
                        pinned
                        on={["hover", "click"]}>
                        Número da nota fiscal, Coluna <b>"G"</b><br />
                        Método de pagamento, Coluna <b>"I"</b><br />
                        Parcela atual, Coluna <b>"J"</b><br />
                        Total de parcelas, Coluna <b>"K"</b><br />
                        Valor fixo por pedido parcelada, Coluna <b>"AD"</b><br />
                        Taxa de transferência, Coluna <b>"AA"</b><br />
                    </Popup>
                    <Popup
                        trigger={
                            <p style={{ display: "inline-block", fontWeight: "bold", marginLeft: "10px" }}>Template MadeiraMadeira</p>
                        }
                        flowing
                        hoverable
                        pinned
                        on={["hover", "click"]}>
                        Pedido , Coluna <b>"D"</b><br />
                        Descrição, Coluna <b>"C"</b><br />
                        Valor , Coluna <b>"B"</b><br />
                        Parcela, Coluna <b>"H"</b><br />
                    </Popup>
                </div>
            </div>
            <div {...getRootProps({ style })}>
                <input {...getInputProps()} />
                <p>Drag 'n' drop xlsx, ou clique para selecionar o arquivo do Marketplace</p>
            </div>
            <aside>
                <h4>Files </h4>
                <ul>{files}</ul>
            </aside>

            <If test={files.length > 0}>
                <Dropdown
                    options={conciListMktPlace}

                    selection
                    placeholder='MarketPlace'
                    name='concimktplaceid'
                    fluid
                    defaultValue={concimktplaceid.toString()}
                    onChange={handleDropMktPlace}


                />

            </If>


        </div>
    );
}

class Conciliacao extends Component {


    state = {
        isSaving: false, openEntrega: false, isSavingNSaiu: false
        , status: '', mensagem: ''
        , isloadingimportacoes: false
        , isloadingimport: false
        , sortColumn: null
        , sortDirection: null
        , repasseSortColumn: null
        , repasseSortDirection: null
    }

    constructor(props) {
        super(props);

    }



    componentDidMount() {

        this.setState({ isloadingimportacoes: true });
        this.props.marketplacesConciliacaoListImportacoesAction().then(d => {
            this.setState({ isloadingimportacoes: false });
        })
    }




    //download pdf from stream blob
    onDownloadXlsx = (arquivonome, arquivo) => {

        let buffer = Buffer.from(arquivo.data);
        let arraybuffer = Uint8Array.from(buffer).buffer;

        const file = new Blob(
            [arraybuffer],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        //const fileURL = URL.createObjectURL(file);
        //window.open(fileURL);
        saveAs(file, `${arquivonome}.xlsx`);

    }


    onChangeDTDeposito = (item, data) => {
        this.props.marketplacesConciliacaoImportHandleChangeAction(item.nurepassemkp, 'dtdeposito', data);
        //console.log("dataaaaaa"+item.nurepassemkp)
        //console.log(data)
    }

    isDateSortColumn = (column) => {
        return column === 'dtimportacao' || column === 'dtdeposito';
    }

    handleSort = (clickedColumn) => () => {
        const { sortColumn, sortDirection } = this.state;

        if (sortColumn !== clickedColumn) {
            this.setState({
                sortColumn: clickedColumn,
                sortDirection: this.isDateSortColumn(clickedColumn) ? 'descending' : 'ascending'
            });
            return;
        }

        this.setState({
            sortDirection: sortDirection === 'ascending' ? 'descending' : 'ascending'
        });
    }

    getDateSortValue = (dateValue) => {
        if (dateValue === null || dateValue === undefined || dateValue === '') {
            return null;
        }

        const parsedDate = moment(dateValue);

        if (!parsedDate.isValid()) {
            return null;
        }

        return parsedDate.valueOf();
    }

    getSortValue = (item, column) => {
        switch (column) {
            case 'id':
                return Number(item.nurepassemkp) || 0;
            case 'arquivo':
                return (item.arquivonome || '').toString().toLowerCase();
            case 'marketplace':
                return (item.mktplace || '').toString().toLowerCase();
            case 'dtimportacao':
                return this.getDateSortValue(item.dtimportacao);
            case 'usuario':
                return (item.login || '').toString().toLowerCase();
            case 'dtdeposito':
                return this.getDateSortValue(item.dtdeposito);
            default:
                return '';
        }
    }

    getSortedImportacoes = () => {
        const { conciimportacoes } = this.props;
        const { sortColumn, sortDirection } = this.state;

        if (!sortColumn) {
            return [...conciimportacoes];
        }

        return [...conciimportacoes].sort((a, b) => {
            const aValue = this.getSortValue(a, sortColumn);
            const bValue = this.getSortValue(b, sortColumn);
            const direction = sortDirection === 'descending' ? -1 : 1;

            if (aValue === null && bValue === null) {
                return 0;
            }

            if (aValue === null) {
                return 1;
            }

            if (bValue === null) {
                return -1;
            }

            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return (aValue - bValue) * direction;
            }

            return aValue.toString().localeCompare(bValue.toString(), 'pt-BR', { numeric: true }) * direction;
        });
    }

    handleRepasseSort = (clickedColumn) => () => {
        const { repasseSortColumn, repasseSortDirection } = this.state;

        if (repasseSortColumn !== clickedColumn) {
            this.setState({
                repasseSortColumn: clickedColumn,
                repasseSortDirection: 'ascending'
            });
            return;
        }

        this.setState({
            repasseSortDirection: repasseSortDirection === 'ascending' ? 'descending' : 'ascending'
        });
    }

    getNumberSortValue = (value) => {
        if (value === null || value === undefined || value === '') {
            return null;
        }

        if (typeof value === 'number') {
            return Number.isNaN(value) ? null : value;
        }

        const normalizedValue = value.toString().trim().replace(/[^\d,.-]/g, '');
        const hasCommaDecimal = normalizedValue.includes(',');
        const numberValue = Number(
            hasCommaDecimal
                ? normalizedValue.replace(/\./g, '').replace(',', '.')
                : normalizedValue
        );

        return Number.isNaN(numberValue) ? null : numberValue;
    }

    getRepasseVlrLiquido = (item) => {
        const valorMitra = this.getNumberSortValue(item.valormitra);
        const valor = this.getNumberSortValue(item.valor);

        if (item.eventoid != 3 || valorMitra === null || valor === null) {
            return null;
        }

        return valorMitra - valor;
    }

    getRepasseIdentificadorKey = (item, index) => {
        if (item.identificador === null || item.identificador === undefined || item.identificador === '') {
            return `sem-identificador-${index}`;
        }

        return item.identificador.toString();
    }

    hasRepasseNufin = (item) => {
        return item.nufin !== null && item.nufin !== undefined && item.nufin.toString().trim() !== '';
    }

    getRepasseDhBaixa = (item) => {
        if (item.dhbaixa === null || item.dhbaixa === undefined) {
            return '';
        }

        return item.dhbaixa.toString().trim();
    }

    getRepasseDhBaixaFormatada = (item) => {
        const dhbaixa = this.getRepasseDhBaixa(item);

        if (dhbaixa === '') {
            return '';
        }

        const parsedDhBaixa = moment(dhbaixa);

        return parsedDhBaixa.isValid() ? parsedDhBaixa.format("DD/MM/YYYY") : dhbaixa;
    }

    getRepassePedidosCount = () => {
        const { concirepasse } = this.props;
        const identificadores = new Set();

        concirepasse.forEach((item, index) => {
            identificadores.add(this.getRepasseIdentificadorKey(item, index));
        });

        return identificadores.size;
    }

    getRepasseBaixadosCount = () => {
        const { concirepasse } = this.props;
        const identificadoresBaixados = new Set();

        concirepasse.forEach((item, index) => {
            if (this.hasRepasseNufin(item)) {
                identificadoresBaixados.add(this.getRepasseIdentificadorKey(item, index));
            }
        });

        return identificadoresBaixados.size;
    }

    getRepasseSortValue = (item, column) => {
        switch (column) {
            case 'nurepassemkp':
                return this.getNumberSortValue(item.nurepassemkp);
            case 'parcela':
                return this.getNumberSortValue(item.parcela);
            case 'sequencia':
                return (item.sequencia || '').toString().toLowerCase();
            case 'identificador':
                return this.getNumberSortValue(item.identificador);
            case 'descricao':
                return (item.descricao || '').toString().toLowerCase();
            case 'valor':
                return this.getNumberSortValue(item.valor);
            case 'taxa':
                return this.getNumberSortValue(item.taxa);
            case 'codparc':
                return this.getNumberSortValue(item.codparc);
            case 'nunota':
                return this.getNumberSortValue(item.nunota);
            case 'nufin':
                return this.getNumberSortValue(item.nufin);
            case 'vlrbaixa':
                return this.getNumberSortValue(item.vlrbaixa);
            case 'vlrmitra':
                return this.getNumberSortValue(item.valormitra);
            case 'vlrliquido':
                return this.getNumberSortValue(this.getRepasseVlrLiquido(item));
            case 'dhbaixa':
                return this.getRepasseDhBaixa(item) || null;
            default:
                return '';
        }
    }

    compareRepasseSortValues = (aValue, bValue, direction) => {
        if (aValue === null && bValue === null) {
            return 0;
        }

        if (aValue === null) {
            return 1;
        }

        if (bValue === null) {
            return -1;
        }

        if (typeof aValue === 'number' && typeof bValue === 'number') {
            return (aValue - bValue) * direction;
        }

        return aValue.toString().localeCompare(bValue.toString(), 'pt-BR', { numeric: true }) * direction;
    }

    getSortedRepasse = () => {
        const { concirepasse } = this.props;
        const { repasseSortColumn, repasseSortDirection } = this.state;

        if (!repasseSortColumn) {
            return [...concirepasse];
        }

        const direction = repasseSortDirection === 'descending' ? -1 : 1;
        const groupsByIdentificador = {};
        const groups = [];

        concirepasse.forEach((item, index) => {
            const groupKey = this.getRepasseIdentificadorKey(item, index);

            if (!groupsByIdentificador[groupKey]) {
                groupsByIdentificador[groupKey] = {
                    firstIndex: index,
                    items: []
                };
                groups.push(groupsByIdentificador[groupKey]);
            }

            groupsByIdentificador[groupKey].items.push(item);
        });

        return groups
            .map(group => ({
                ...group,
                items: [...group.items].sort((a, b) => this.compareRepasseSortValues(
                    this.getRepasseSortValue(a, repasseSortColumn),
                    this.getRepasseSortValue(b, repasseSortColumn),
                    direction
                ))
            }))
            .sort((a, b) => {
                const compareResult = this.compareRepasseSortValues(
                    this.getRepasseSortValue(a.items[0], repasseSortColumn),
                    this.getRepasseSortValue(b.items[0], repasseSortColumn),
                    direction
                );

                return compareResult !== 0 ? compareResult : a.firstIndex - b.firstIndex;
            })
            .reduce((items, group) => items.concat(group.items), []);
    }



    render() {
        let { loader

            , concimktplaceid, conciListMktPlace

            , conciimportacoes
            , conciimportacoesloader
            , conciisimporting
            , conciarquivojson
            , conciarquivobuffer
            , concirepasse, concirepasselog

            , marketplacesConciliacaoHandleChangeAction
            , marketplacesConciliacaoImportAction
            , marketplacesConciliacaoImportArquivoAction
            , marketplacesConciliacaoListImportacoesAction
            , marketplacesConciliacaoProcessImportacoesAction
            , marketplacesConciliacaoListRepasseAction
            , marketplacesConciliacaoDeleteAction

        } = this.props;
        const { sortColumn, sortDirection, repasseSortColumn, repasseSortDirection } = this.state;
        const sortedImportacoes = this.getSortedImportacoes();
        const sortedRepasse = this.getSortedRepasse();
        const repassePedidosCount = this.getRepassePedidosCount();
        const repasseBaixadosCount = this.getRepasseBaixadosCount();


        const getstatus = (acao) => {
            if (acao == 0) {
                return "Aguardando Processar"
            } else if (acao == 1) {
                return "Processado"
            } else if (acao == 2) {
                return "Baixado"
            } else {
                return "-----"

            }


        }


        let identificador = -999;
        let mostralinha = false;

        return (
            <Tab.Pane loading={false}>
                <Segment>
                    <StyledDropzone
                        concimktplaceid={concimktplaceid}
                        conciListMktPlace={conciListMktPlace}
                        conciarquivojson={conciarquivojson}
                        marketplacesConciliacaoHandleChangeAction={marketplacesConciliacaoHandleChangeAction}
                        marketplacesConciliacaoImportAction={marketplacesConciliacaoImportAction}
                        marketplacesConciliacaoImportArquivoAction={marketplacesConciliacaoImportArquivoAction}
                        marketplacesConciliacaoListImportacoesAction={marketplacesConciliacaoListImportacoesAction}

                    />
                    <If test={concimktplaceid != '0' && conciarquivojson.length > 0}>
                        <Button content='Importar' primary onClick={() => {

                            marketplacesConciliacaoImportAction().then(d => {
                                this.setState({ mensagem: d[0].mensagem, status: d[0].status })
                            }).catch(err => {
                                console.log(err)
                            })

                        }} />
                    </If>

                    <If test={this.state.mensagem != ''}>
                        <Message attached='top' color={(this.state.status === 'OK' ? 'olive' : 'red')}>
                            {
                                this.state.mensagem.includes('<br>')
                                    ? (() => {
                                        const linhas = this.state.mensagem.split('<br>').filter(l => l.trim() !== '');
                                        const primeiraLinha = linhas[0];
                                        const restanteLinhas = linhas.slice(1);

                                        return (
                                            <>
                                                <div>{primeiraLinha}</div>

                                                {restanteLinhas.length > 0 && (
                                                    <ul style={{ marginTop: '8px' }}>
                                                        {restanteLinhas.map((linha, index) => (
                                                            <li
                                                                key={index}
                                                                style={{
                                                                    color: linha.includes('Evento:') ? 'red' : 'inherit'
                                                                }}
                                                            >
                                                                {linha}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </>
                                        );
                                    })()
                                    : this.state.mensagem
                            }
                        </Message>
                    </If>

                </Segment>
                <br></br><br></br>

                <If test={this.state.isloadingimportacoes}>
                    <Segment>
                        <Dimmer active inverted>
                            <Loader size='large'>Carregando importações</Loader>
                        </Dimmer>

                        <Image src='/img/paragraph.png' />
                    </Segment>
                </If>

                <If test={conciimportacoes.length > 0 && !this.state.isloadingimportacoes}>

                    <StyledTable celled sortable id={'12121'} compact='very' size='small'>
                        <StyledTableHeader>
                            <Table.Row>
                                <Table.HeaderCell width="1" sorted={sortColumn === 'id' ? sortDirection : null} onClick={this.handleSort('id')}>ID</Table.HeaderCell>
                                <Table.HeaderCell width="2" sorted={sortColumn === 'arquivo' ? sortDirection : null} onClick={this.handleSort('arquivo')}>Arquivo</Table.HeaderCell>
                                <Table.HeaderCell width="2" sorted={sortColumn === 'marketplace' ? sortDirection : null} onClick={this.handleSort('marketplace')}>MarketPlace</Table.HeaderCell>
                                <Table.HeaderCell width="2" sorted={sortColumn === 'dtimportacao' ? sortDirection : null} onClick={this.handleSort('dtimportacao')}>Dt Importaçao</Table.HeaderCell>
                                <Table.HeaderCell width="2" sorted={sortColumn === 'usuario' ? sortDirection : null} onClick={this.handleSort('usuario')}>Usuário</Table.HeaderCell>
                                <Table.HeaderCell width="1">Status</Table.HeaderCell>
                                <Table.HeaderCell width="2">Ações</Table.HeaderCell>

                                <Table.HeaderCell width="3" sorted={sortColumn === 'dtdeposito' ? sortDirection : null} onClick={this.handleSort('dtdeposito')}>Depósito</Table.HeaderCell>
                                {
                                    /*
                                    <Table.HeaderCell width="1">Excluir</Table.HeaderCell>
                                    */
                                }


                            </Table.Row>
                        </StyledTableHeader>

                        <StyledTableBody>
                            {

                                sortedImportacoes.map(item => (

                                    <Table.Row key={`id${item.nurepassemkp}`}>
                                        <Table.Cell>{item.nurepassemkp}</Table.Cell>
                                        <Table.Cell>{item.arquivonome}</Table.Cell>
                                        <Table.Cell>{item.mktplace}</Table.Cell>
                                        <Table.Cell>{moment(item.dtimportacao).format("DD/MM/YYYY HH:mm")}</Table.Cell>
                                        <Table.Cell>{item.login}</Table.Cell>
                                        <Table.Cell>{getstatus(item.status)}</Table.Cell>

                                        <Table.Cell>
                                            <If test={item.status == 0}>

                                                <Popup
                                                    trigger={<Button icon='cog' color={'grey'} size="mini"
                                                        loading={item.isprocessing}
                                                        onClick={(e) => (item.isprocessing == false ? marketplacesConciliacaoProcessImportacoesAction(item.nurepassemkp) : null)}

                                                    />}
                                                    content={`Realiza processamento do Arquivo importado para buscar informações no ERP`} wide='very'
                                                />


                                            </If>
                                            <If test={item.status == 1 || item.status == 2}>


                                                <Popup
                                                    trigger={<Button icon='folder open' color={'blue'} size="mini"
                                                        loading={item.islistingrepasse}
                                                        onClick={(e) => (item.islistingrepasse == false ? marketplacesConciliacaoListRepasseAction(item.nurepassemkp) : null)}

                                                    />}
                                                    content={`Exibe detalhes do processamento`} wide='very'
                                                />



                                            </If>


                                            <Popup
                                                trigger={<Button icon='file excel outline ' color={'green'} size="mini"
                                                    loading={false}
                                                    onClick={(e) => this.onDownloadXlsx(item.arquivonome, item.arquivo)}

                                                />}
                                                content={`Faz download do arquivo importado`} wide='very'
                                            />



                                            <If test={item.status == 0 || item.status == 1}>
                                                <Popup
                                                    trigger={<Button icon='remove ' color={'red'} size="mini"
                                                        loading={item.isloadingdelete}
                                                        onClick={(e) => marketplacesConciliacaoDeleteAction(item.nurepassemkp)}
                                                    //onClick={(e) => this.onChangeDevolucao(e, pedido, carga)}
                                                    />}
                                                    content={`Remover o arquivo e todos itens processados nele.`} wide='very'
                                                />




                                            </If>

                                        </Table.Cell>







                                        <Table.Cell>

                                            <If test={item.status == 2}>
                                                {moment(item.dtdeposito).format("DD/MM/YYYY HH:mm")}
                                            </If>

                                            <If test={item.status == 1}>
                                                <DateTimePicker
                                                    onChange={(e) => { this.onChangeDTDeposito(item, e) }}

                                                    value={
                                                        new Date(item.dtdeposito)

                                                    }
                                                    locale="pt-br"
                                                    required={true}
                                                    clearIcon=""
                                                    disableClock={true}
                                                    isClockOpen={false}

                                                />


                                                <Popup
                                                    trigger={
                                                        <Button key={`save_${item.nurepassemkp}`}
                                                            icon={'gavel'} color={'orange'} size="mini"
                                                            onClick={(e) => {
                                                                if (!item.isprocessandobaixa) {
                                                                    this.props.marketplacesConciliacaoRepasseAction(item.nurepassemkp, item.dtdeposito).then(d => {
                                                                        //alert('retornou no componente');

                                                                        this.setState({ mensagem: d[0].mensagem, status: d[0].status })
                                                                    })
                                                                }
                                                            }}
                                                            loading={item.isprocessandobaixa}
                                                        />

                                                    }
                                                    content={`Realizar a baixa de acordo com a data de depósito ${moment(item.dtdeposito).format("DD/MM/YYYY HH:mm")}. Esse processo pode demorar em até 10 minutos para ser executado e não pode sair dessa tela até receber uma confirmação de processameto.`} wide='very'
                                                />



                                            </If>



                                        </Table.Cell>



                                    </Table.Row>

                                ))

                            }


                        </StyledTableBody>
                    </StyledTable>

                </If>






                <br></br><br></br>

                <If test={concirepasse.length > 0}>
                    <Statistic.Group>
                        <Statistic>
                            <Statistic.Value>{concirepasse[0]?.nurepassemkp}</Statistic.Value>
                            <Statistic.Label>NUREPASSE</Statistic.Label>
                        </Statistic>
                        <Statistic>
                            <Statistic.Value>{concirepasse.length}</Statistic.Value>
                            <Statistic.Label>Linhas</Statistic.Label>
                        </Statistic>
                        <Statistic color={(concirepasselog.length > 0 ? 'red' : 'green')}>
                            <Statistic.Value>{concirepasselog.length}</Statistic.Value>
                            <Statistic.Label>Problemas</Statistic.Label>
                        </Statistic>
                    </Statistic.Group>

                </If>

                <If test={concirepasselog.length > 0}>

                    <StyledTable celled id={'concirepasselog'} color='red' inverted compact='very' size='small' loading={true}>
                        <StyledTableHeader>
                            <Table.Row>
                                <Table.HeaderCell width="1">NUREPASSEMKP</Table.HeaderCell>
                                <Table.HeaderCell width="1">Parcela</Table.HeaderCell>
                                <Table.HeaderCell width="1">Sequencia</Table.HeaderCell>
                                <Table.HeaderCell width="2">Identificador</Table.HeaderCell>
                                <Table.HeaderCell width="4">Motivo</Table.HeaderCell>
                            </Table.Row>
                        </StyledTableHeader>

                        <StyledTableBody>
                            {

                                concirepasselog.map(item => (

                                    <Table.Row key={`rep${item.nurepassemkp} ${item.Identificador}`}>
                                        <Table.Cell>{item.nurepassemkp}</Table.Cell>
                                        <Table.Cell>{item.parcela}</Table.Cell>
                                        <Table.Cell>{item.sequencia}</Table.Cell>
                                        <Table.Cell>{item.identificador}</Table.Cell>
                                        <Table.Cell>{item.motivo}</Table.Cell>

                                    </Table.Row>

                                ))


                            }


                        </StyledTableBody>

                    </StyledTable>

                </If>


                <br></br><br></br>


                <If test={concirepasse.length > 0}>
                    <Table fullWidth>
                        <Table.Row>
                            <Table.HeaderCell colSpan='14'>
                                Pedidos: {repassePedidosCount}
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table>

                    <StyledTable celled sortable id={'concirepasse'} compact='very' size='small' loading={true}>
                        <StyledTableHeader>
                            <Table.Row>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'nurepassemkp' ? repasseSortDirection : null} onClick={this.handleRepasseSort('nurepassemkp')}>NUREPASSEMKP</Table.HeaderCell>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'parcela' ? repasseSortDirection : null} onClick={this.handleRepasseSort('parcela')}>Parcela</Table.HeaderCell>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'sequencia' ? repasseSortDirection : null} onClick={this.handleRepasseSort('sequencia')}>Sequencia</Table.HeaderCell>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'identificador' ? repasseSortDirection : null} onClick={this.handleRepasseSort('identificador')}>Identificador</Table.HeaderCell>
                                <Table.HeaderCell width="2" sorted={repasseSortColumn === 'descricao' ? repasseSortDirection : null} onClick={this.handleRepasseSort('descricao')}>Descrição</Table.HeaderCell>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'valor' ? repasseSortDirection : null} onClick={this.handleRepasseSort('valor')}>Valor</Table.HeaderCell>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'taxa' ? repasseSortDirection : null} onClick={this.handleRepasseSort('taxa')}>Taxa</Table.HeaderCell>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'codparc' ? repasseSortDirection : null} onClick={this.handleRepasseSort('codparc')}>CodParc</Table.HeaderCell>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'nunota' ? repasseSortDirection : null} onClick={this.handleRepasseSort('nunota')}>NuNota</Table.HeaderCell>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'nufin' ? repasseSortDirection : null} onClick={this.handleRepasseSort('nufin')}>NuFin <span style={{ color: 'green', fontWeight: 'bold' }}> ({repasseBaixadosCount})</span></Table.HeaderCell>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'vlrbaixa' ? repasseSortDirection : null} onClick={this.handleRepasseSort('vlrbaixa')}>VlrBaixa</Table.HeaderCell>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'vlrmitra' ? repasseSortDirection : null} onClick={this.handleRepasseSort('vlrmitra')}>VlrMitra</Table.HeaderCell>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'vlrliquido' ? repasseSortDirection : null} onClick={this.handleRepasseSort('vlrliquido')}>VlrLiquido</Table.HeaderCell>
                                <Table.HeaderCell width="1" sorted={repasseSortColumn === 'dhbaixa' ? repasseSortDirection : null} onClick={this.handleRepasseSort('dhbaixa')}>Baixa</Table.HeaderCell>
                            </Table.Row>
                        </StyledTableHeader>

                        <StyledTableBody>
                            { //

                                sortedRepasse.map((item, index) => {
                                    if (identificador == item.identificador) {
                                        mostralinha = false;


                                    } else {
                                        mostralinha = true;
                                        identificador = item.identificador;
                                    }


                                    return (



                                        <React.Fragment key={`rep${item.nurepassemkp} ${item.identificador} ${item.sequencia} ${item.nufin} ${index}`}>

                                            <If test={mostralinha}>
                                                <Table.Row>
                                                    <Table.Cell colSpan='14'><hr></hr></Table.Cell>
                                                </Table.Row>
                                            </If>
                                            <Table.Row>
                                                <Table.Cell>{item.nurepassemkp}</Table.Cell>
                                                <Table.Cell>{item.parcela}</Table.Cell>
                                                <Table.Cell>{item.sequencia}</Table.Cell>
                                                <Table.Cell>{item.identificador}</Table.Cell>
                                                <Table.Cell positive={(item.recdesp == 1 ? true : false)} negative={(item.recdesp == 1 ? false : true)}>{item.descricao}</Table.Cell>
                                                <Table.Cell positive={(item.recdesp == 1 ? true : false)} negative={(item.recdesp == 1 ? false : true)}>{(item.recdesp == 1 ? '+' : '-')}{item.valor.toFixed(2)}</Table.Cell>
                                                <Table.Cell negative={(item.taxa == null ? false : true)}>{(item.taxa == null ? '' : '-')}{item.taxa}</Table.Cell>
                                                <Table.Cell negative={(item.codparc == null ? true : false)}>{item.codparc}</Table.Cell>
                                                <Table.Cell negative={(item.nunota == null ? true : false)}>{item.nunota}</Table.Cell>
                                                <Table.Cell negative={(item.nufin == null ? true : false)}>{item.nufin}</Table.Cell>
                                                <Table.Cell negative={(item.vlrbaixa == null ? true : false)}>{item.vlrbaixa}</Table.Cell>
                                                <Table.Cell negative={(item.valormitra == null ? true : false)}>{(item.valormitra != null ? item.valormitra.toFixed(2) : '')}</Table.Cell>
                                                <Table.Cell>{(this.getRepasseVlrLiquido(item) != null ? this.getRepasseVlrLiquido(item).toFixed(2) : '')}</Table.Cell>
                                                <Table.Cell positive={this.getRepasseDhBaixa(item) !== ''} negative={this.getRepasseDhBaixa(item) === ''}>
                                                    {this.getRepasseDhBaixa(item) !== '' ? `Baixado` : 'Não baixado'}
                                                </Table.Cell>
                                            </Table.Row>




                                        </React.Fragment>

                                    )
                                })
                            }


                        </StyledTableBody>

                        {/* <Table.Footer fullWidth>
                            <Table.Row>
                                <Table.HeaderCell colSpan='14'>
                                    Pedidos: {repassePedidosCount}
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer> */}
                    </StyledTable>

                </If>





            </Tab.Pane >

        )
    }
}

Conciliacao.defaultProps = {
    loader: true
    , login: ''
    , concimktplaceid: ''
    , conciListMktPlace: []

    , conciimportacoes: []
    , conciimportacoesloader: false
    , conciisimporting: false
    , conciarquivojson: []
    , conciarquivobuffer: []
    , conciarquivonome: ''
    , concirepasse: []
    , concirepasselog: []

};

Conciliacao.propTypes = {

    loader: PropTypes.bool.isRequired
    , login: PropTypes.string.isRequired
    , concirepasse: PropTypes.array.isRequired
    , concirepasselog: PropTypes.array.isRequired

    , concimktplaceid: PropTypes.string.isRequired
    , conciListMktPlace: PropTypes.array.isRequired

    , marketplacesConciliacaoHandleChangeAction: PropTypes.func.isRequired
    , marketplacesConciliacaoListImportacoesAction: PropTypes.func.isRequired
    , marketplacesConciliacaoImportAction: PropTypes.func.isRequired
    , marketplacesConciliacaoImportArquivoAction: PropTypes.func.isRequired
    , marketplacesConciliacaoProcessImportacoesAction: PropTypes.func.isRequired
    , marketplacesConciliacaoListRepasseAction: PropTypes.func.isRequired
    , marketplacesConciliacaoImportHandleChangeAction: PropTypes.func.isRequired
    , marketplacesConciliacaoRepasseAction: PropTypes.func.isRequired
    , marketplacesConciliacaoDeleteAction: PropTypes.func.isRequired

};



export default Conciliacao
